<template>
  <section class="page">
    <div class="grid grid-cols-3 gap-5">
      <div class="col-span-full md:col-span-1">
        <img
          alt="بنا و نما"
          src="../assets/image-bananama.jpg"
          class="w-full rounded"
        />
      </div>
      <div class="col-span-full md:col-span-2">
        <h2 class="page-title">ثبت نام رایگان</h2>
        <p>
          در صورتی که سایت شما در زمینه خدمات ساختمانی فعالیت دارد، میتوانید به
          صورت رایگان آن را در سایت ثبت نمایید.
        </p>
        <div class="grid grid-cols-2 gap-5 py-3">
          <a
            href="tel:+98-9108160300"
            class="button col-span-full is-large is-primary"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              class="size-7"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
              />
            </svg>
            <span dir="ltr">0910 81 60 300</span></a
          >
          <a
            href="tg://resolve?domain=o9108160300"
            class="button col-span-1 is-large is-primary"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              class="size-7"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
              />
            </svg>
            <span>تلگرام</span></a
          >
          <a
            href="https://web.whatsapp.com/send?phone=+989108160300"
            class="button col-span-1 is-large is-primary"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              class="size-7"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
              />
            </svg>
            <span>واتساپ</span></a
          >
        </div>
        <p>
          <strong>توجه</strong>: در بانک اطلاعات مشاغل بنا نما فقط آدرس سایت درج
          میگردد و امکان ثبت آدرس صفحات تلگرام و اینستاگرام وجود ندارد.<br />
          در صورت تمایل میتوانید کانال تلگرام و صفحه اینستاگرام خود را از طریق
          سیستم تبلیغات هدفمند به دیگران معرفی نمایید.
        </p>
      </div>
    </div>
  </section>
</template>
